import { useMediaQuery } from "@mui/material";
import Link from "next/link";
import { stateRegions } from "../../../helpers/constant";
import { FlexContainer, SectionContainer, TextStyled } from "../styles";
import { AddressIcon, MapContainer } from "./styles";

function CompanyAddress(props) {
  const { companyDetail } = props || {};

  const isTablet = useMediaQuery("(min-width: 640px)");

  const companyAddress = companyDetail?.address;
  const latitude = companyDetail?.latitude;
  const longitude = companyDetail?.longitude;
  const checkAddress = stateRegions?.filter((state) =>
    companyAddress?.toLowerCase()?.includes(state?.stateRegion?.toLowerCase())
  );

  function handleAddress() {
    //Regex example: 51900 Kuala Lumpur
    const pattern = new RegExp(`\\d{5}\\s+${checkAddress[0]?.stateRegion}`);
    const stateInAddressFormat = [
      companyAddress && companyAddress?.match(pattern),
      checkAddress[0]?.stateRegion + " ,",
      checkAddress[0]?.stateRegion + ",",
      checkAddress[0]?.stateRegion + " .",
      checkAddress[0]?.stateRegion + ".",
      ", " + checkAddress[0]?.stateRegion,
      " ," + checkAddress[0]?.stateRegion,
      checkAddress[0]?.stateRegion,
    ];
    const checkFormattedAddress = stateInAddressFormat?.filter((state) =>
      companyAddress?.includes(state)
    );

    //check is array of array/array/not array
    const formattedAddress = Array.isArray(checkFormattedAddress)
      ? Array.isArray(checkFormattedAddress[0])
        ? checkFormattedAddress[0][0]
        : checkFormattedAddress[0]
      : checkFormattedAddress[0];
    const splittedAddress = companyAddress?.split(formattedAddress);

    return splittedAddress?.length > 0 && splittedAddress?.length < 3 ? (
      <>
        {splittedAddress?.length == 1 ? (
          <>
            {splittedAddress[0]}
            <Link
              href={handleLocationHref()}
              style={{ textDecoration: "none", color: "currentcolor" }}
            >
              {formattedAddress}
            </Link>
          </>
        ) : (
          <>
            <>
              {splittedAddress[0]}
              <Link
                href={handleLocationHref()}
                style={{ textDecoration: "none", color: "currentcolor" }}
              >
                {formattedAddress}
              </Link>
              {splittedAddress[1]}
            </>
          </>
        )}
      </>
    ) : (
      <>{companyAddress}</>
    );
  }

  function handleLocationHref() {
    return `/companies?state_regions=${checkAddress[0]?.stateRegion.replaceAll(
      " ",
      "+"
    )}&triggerOrigin=cdp-text`;
  }

  return (
    <SectionContainer aria-label="company address section" id="CompanyAddress">
      <FlexContainer flexDirection={isTablet ? "row" : "column"} gap={"1rem"}>
        <FlexContainer
          flexDirection={"column"}
          gap={"1rem"}
          sx={{ width: "fit-content" }}
        >
          <FlexContainer alignItems="center" gap={"0.5rem"}>
            <AddressIcon />
            <TextStyled
              variant="h2"
              fontSize="1.25rem"
              fontWeight={700}
              textTransform="capitalize"
              aria-label="company address section title"
              color={"#000"}
            >
              Our Address
            </TextStyled>
          </FlexContainer>
          <TextStyled
            variant="body1"
            fontFamily={"karla"}
            fontSize="0.875rem"
            letterSpacing={"0.15px"}
            width={isTablet ? "14.625rem" : "100%"}
            sx={{ overflowWrap: "anywhere" }}
          >
            {handleAddress()}
            {/* {companyAddress} */}
          </TextStyled>
        </FlexContainer>
        <MapContainer
          width="100%"
          src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAx7NwqSnIRQ9U22sZLd5rMIfWf5J4YmEk&q=${latitude}+${longitude}`}
        />
      </FlexContainer>
    </SectionContainer>
  );
}

export default CompanyAddress;
